import Vue from 'vue';

export const eventManager = new Vue();

eventManager.getUniqueId = eventName => {
    const randomString = Math.random().toString(36).substring(7);
    return `${eventName}-${new Date().getTime()}-${randomString}`;
}